import React from 'react';
import Text from 'components/base/Text';
import { Flex, Separator, Padding } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { SPACES } from 'common/constants/sizes';
import language from 'common/language/en.lang';
import { StyledSVG } from './SlackConnectedTopBar';
import Bell from 'images/icons/bell.svg';
import { Tooltip } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import ReAuthorizeInformationToolTip from './ReAuthorizeTooltip';
import styled from 'styled-components';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const {
  reauthorizeText,
  contactSupportText,
  reAuthorizeMissingScopeText,
  upgradeYourSlackText,
  reAuthorizeInvalidTokenText,
  contactAdminForReAuth
} = language.Setting.Slack.reauthorize;

const IconWrapper = styled(Flex)`
  width: 2.2rem;
  height: 2.2rem;
  margin-bottom: 0.3rem;
`;

const ConnectionState = ({
  isConnected,
  icon,
  color,
  teamSlackChannel,
  isTeamSettings
}) => {
  const teamSlackChannelConnected = teamSlackChannel || !isTeamSettings;
  return (
    <>
      <Separator height='2rem' margin='0 2rem' />
      {teamSlackChannelConnected && (
        <Icon name={icon} color={color} size='smaller' />
      )}
      <Text size='medium' color={color} pl={SPACES.small}>
        {`${isConnected ? '' : 'Not '}Connected`}
      </Text>
      <Text size='medium' color={color} pl={SPACES['x-small']}>
        {teamSlackChannelConnected ? '' : '-  No channel selected'}
      </Text>
    </>
  );
};
export const ConnectedState = ({ teamSlackChannel, isTeamSettings }) => (
  <ConnectionState
    isConnected
    icon='successOutline'
    color={!teamSlackChannel && isTeamSettings ? 'shuttleGray' : 'funGreen'}
    teamSlackChannel={teamSlackChannel}
    isTeamSettings={isTeamSettings}
  />
);
export const NotConnectedState = () => (
  <ConnectionState isConnected={false} icon='errorOutline' color='osloGray' />
);

export const SlackInvalidTokenState = ({
  connectToSlack,
  contactSupport,
  isReAuthAllowed
}) => {
  return (
    <>
      <Separator height='2rem' margin='0 2rem' />
      <Icon name='warning' color='orangePeel' size='medium' />
      <Text ml='0.4rem' size='medium'>
        {reAuthorizeInvalidTokenText()}
      </Text>

      <Separator height='2rem' margin='0 1.25rem' />
      <Text
        size='medium'
        color='chambray'
        cursor='pointer'
        disabled={!isReAuthAllowed}
        title={!isReAuthAllowed ? contactAdminForReAuth : ''}
        onClick={() => {
          if (isReAuthAllowed) {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.SETTINGS,
              page_tab: TRACKING.PAGE_TABS.ORG_SLACK,
              click_type: TRACKING.CLICK.FIX_SLACK
            });
            connectToSlack();
          }
        }}
      >
        {reauthorizeText()}
      </Text>

      <Separator height='2rem' margin='0 1.25rem' />
      <Text
        size='medium'
        color='chambray'
        cursor='pointer'
        onClick={contactSupport}
      >
        {contactSupportText()}
      </Text>
    </>
  );
};

export const SlackMissingScopesState = ({ connectToSlack }) => {
  return (
    <>
      <Separator height='2rem' margin='0 1.25rem' />
      <StyledSVG src={Bell} width='2.4rem' height='2.4rem' />
      <Text size='medium' color='shark'>
        {reAuthorizeMissingScopeText()}
      </Text>
      <Text
        size='medium'
        color='chambray'
        cursor='pointer'
        ml='0.7rem'
        mr='0.4rem'
        onClick={() => {
          TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
            page: TRACKING.PAGES.SETTINGS,
            page_tab: TRACKING.PAGE_TABS.ORG_SLACK,
            click_type: TRACKING.CLICK.UPGRADE_SLACK
          });
          connectToSlack();
        }}
      >
        {upgradeYourSlackText()}
      </Text>
      <ReAuthorizeInformationToolTip>
        <IconWrapper cursor='pointer'>
          <Icon name='infooutlined' size='small' />
        </IconWrapper>
      </ReAuthorizeInformationToolTip>
    </>
  );
};

export const SlackTeamConnectedState = ({
  isNotificationsChecked,
  toggleNotificationsForTeam,
  notConnected
}) => {
  return (
    <>
      <Separator height='2rem' margin='0 2rem' />

      <Tooltip
        placement='top'
        title={
          <Flex direction='row' items='center'>
            <Flex>
              <Icon
                name={isNotificationsChecked ? 'alarmDisabled' : 'alarm'}
                color='shuttleGray'
                size='x-small'
              />
            </Flex>
            <Padding l='x-small'>
              {isNotificationsChecked
                ? 'Turn off all notications'
                : 'Turn on notications'}
            </Padding>
          </Flex>
        }
      >
        <Switch
          onChange={toggleNotificationsForTeam}
          checked={isNotificationsChecked}
          disabled={notConnected}
        />
      </Tooltip>
      <Text
        size='medium'
        pl={SPACES.small}
        color={isNotificationsChecked ? null : 'osloGray'}
      >
        {isNotificationsChecked
          ? 'Slack notifications on'
          : 'Slack notifications are muted for this team'}
      </Text>
    </>
  );
};
